import React from 'react';
import checkIcon from '../../../assets/icons/check.svg';
import checksIcon from '../../../assets/icons/checks.svg';
import user_profile_photo from '../../images/def_user_icon.svg';
import { t } from 'i18next';

const ChatUserItem = ({ user, onClick, isActive, currentUserId, isPinned }) => {
  const SPECIAL_SERVICE_IDS = [31, 1001, 1002, 1003, 1004];
  const MESSAGABLE_SERVICE_IDS = [31, 1003];

  const isSpecialService = SPECIAL_SERVICE_IDS.includes(user.sender_id) || SPECIAL_SERVICE_IDS.includes(user.receiver_id);
  const isMessagableService = MESSAGABLE_SERVICE_IDS.includes(user.sender_id) || MESSAGABLE_SERVICE_IDS.includes(user.receiver_id);
  const isReadOnlyService = isSpecialService && !isMessagableService;

  const getServiceName = () => (user.sender_id === currentUserId ? user.receiver_name : user.sender_name);
  const isBuying = currentUserId && user.announcement_author_id !== currentUserId && !isSpecialService;
  const isSelling = currentUserId && user.announcement_author_id === currentUserId && !isSpecialService;

  const displayName = isSpecialService
    ? getServiceName()
    : (user.sender_id === currentUserId ? user.receiver_name : user.sender_name);

  const formatTimestamp = (timestamp) => {
    const date = new Date(timestamp);
    const hours = String(date.getUTCHours()).padStart(2, "0");
    const minutes = String(date.getUTCMinutes()).padStart(2, "0");
    return `${hours}:${minutes}`;
  };

  // Get announcement image for thumbnail
  const announcementImage = user.announcement_image_url || null;

  return (
    <div
      className={`flex items-center px-4 py-3 cursor-pointer w-full box-border transition-colors border-b border-gray-50
        ${isActive ? "bg-[#147F26]/5 border-l-2 border-l-[#147F26]" : "hover:bg-gray-50"}
        ${isReadOnlyService ? "opacity-70" : ""}
      `}
      onClick={() => onClick(user)}
    >
      {/* Avatar */}
      <div className="relative flex-shrink-0 mr-3">
        <img
          src={user_profile_photo}
          alt={displayName}
          className="w-11 h-11 rounded-full object-cover border border-gray-100"
        />
        {isSpecialService && (
          <span className="absolute bottom-0 right-0 w-2.5 h-2.5 bg-[#147F26] border-2 border-white rounded-full" />
        )}
      </div>

      {/* Content */}
      <div className="flex-1 min-w-0">
        {/* Name + time */}
        <div className="flex items-center justify-between mb-0.5">
          <span className="text-sm font-semibold text-gray-900 truncate">{displayName}</span>
          <span className="text-xs text-gray-400 flex-shrink-0 ml-2">
            {user.timestamp ? formatTimestamp(user.timestamp) : ''}
          </span>
        </div>

        {/* Badges row */}
        {!isSpecialService && (isBuying || isSelling || user.announcement_status) && (
          <div className="flex items-center gap-1.5 mb-0.5">
            {isBuying && (
              <span className="px-1.5 py-0.5 rounded text-[10px] font-medium bg-[#147F26]/10 text-[#147F26] border border-[#147F26]/30">
                {t('buying')}
              </span>
            )}
            {isSelling && (
              <span className="px-1.5 py-0.5 rounded text-[10px] font-medium bg-orange-100 text-orange-600 border border-orange-200">
                {t('selling')}
              </span>
            )}
            {user.announcement_status && (
              <span className={`px-1.5 py-0.5 rounded text-[10px] border
                ${user.announcement_status === 'active'
                  ? 'border-[#147F26]/40 text-[#147F26] bg-white'
                  : 'border-gray-300 text-gray-500 bg-white'}`}>
                {user.announcement_status === 'active' ? t('active') || 'Активно' : t('inactive') || 'Неактивно'}
              </span>
            )}
          </div>
        )}

        {/* Last message + unread */}
        <div className="flex items-center justify-between">
          <span className="text-xs text-gray-500 truncate flex-1">
            {user.message || ''}
          </span>
          <div className="flex items-center gap-1 flex-shrink-0 ml-2">
            {user.isChecked !== null && user.isChecked !== undefined && (
              <img
                src={user.isChecked ? checksIcon : checkIcon}
                alt="check"
                className="w-3.5 h-3.5"
              />
            )}
            {user.unread_count > 0 && (
              <span className="bg-[#147F26] text-white rounded-full w-5 h-5 text-[10px] font-bold flex items-center justify-center">
                {user.unread_count > 99 ? '99+' : user.unread_count}
              </span>
            )}
          </div>
        </div>
      </div>

      {/* Announcement thumbnail */}
      {announcementImage && (
        <img
          src={announcementImage}
          alt="товар"
          className="w-10 h-10 rounded-lg object-cover ml-2 flex-shrink-0 border border-gray-100"
        />
      )}
    </div>
  );
};

export default ChatUserItem;
